module.exports = __webpack_public_path__ + "img/agent-default.68365c4e.png";